import { INITIALIZE,TOGGLE_SUBSCRIPTION,SAVING_SUBSCRIPTION,UPDATED_SUBSCRIPTION } from '../actions/types';
const initialState = {
    selected: null,
    saved: null,
    messageType: 'unsubscribe',
    isSaving: false,
    isUpdated: false,
    updateSuccess: null
};

export default function (state = initialState,action) {
    switch(action.type) {
        case(INITIALIZE):
            if(!action.recipient) {
                return state;
            }

            var isOptOut = 0;
            var recipient = action.recipient;
            if(
                (recipient.unsubscribed && !recipient.group_resubscribed) ||
                (recipient.group_unsubscribed && !recipient.group_resubscribed) ||
                (recipient.unsubscribed && recipient.unsubscribed > recipient.group_resubscribed) ||
                (recipient.group_unsubscribed && recipient.group_unsubscribed > recipient.group_resubscribed)
            ) {
                isOptOut = 1;
            }

            return {
                ...state,
                selected: isOptOut,
                saved: isOptOut
            }
        case(TOGGLE_SUBSCRIPTION):
            return {
                ...state,
                selected: action.isOptOut,
                isUpdated: false
            }
        case(SAVING_SUBSCRIPTION):
            return {
                ...state,
                selected: action.isOptOut,
                isSaving: true,
                isUpdated: false
            }
        case(UPDATED_SUBSCRIPTION):
            var newState = {
                ...state,
                saved: state.selected,
                isSaving: false,
                updateSuccess: action.updateSuccess
            }

            if(action.updateSuccess) {
                newState.messageType = newState.selected ? 'unsubscribe' : 'subscribe';
                newState.isUpdated = newState.messageType === state.messageType;
            } else {
                newState.isUpdated = true;
            }
            return newState;
        default:
            return state;
    }

    
}